import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

/**
 * Depuis React 16, une exception levée pendant le rendu démonte tout l'arbre si
 * aucune ErrorBoundary ne la rattrape : l'application devient une page blanche.
 * Elle affiche ici un message avec un bouton de rechargement à la place.
 */
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor (props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch (error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Erreur non rattrapée :', error, errorInfo)
  }

  render (): React.ReactNode {
    if (this.state.hasError) {
      return (
        <Wrapper>
          <h4><FormattedMessage id='errorBoundaryTitle' /></h4>
          <p><FormattedMessage id='errorBoundaryText' /></p>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => { window.location.reload() }}
          >
            <FormattedMessage id='errorBoundaryReload' />
          </button>
        </Wrapper>
      )
    }

    return this.props.children
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 1rem;
  color: var(--texte-table);
`

export default ErrorBoundary
